export var TaskTypes;
(function (TaskTypes) {
    TaskTypes["WATCH_VIDEO"] = "watch-video";
    TaskTypes["OPERATIONAL"] = "operation";
    TaskTypes["GOVERNANCE"] = "governance";
})(TaskTypes || (TaskTypes = {}));
export default TaskTypes;



//////////////////
// WEBPACK FOOTER
// ./src/enums/TaskTypes.ts
// module id = 147
// module chunks = 81